import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { ErrorBoundary } from './components/ErrorBoundary.jsx'
import { CrisisLifeline } from './components/CrisisLifeline.jsx'
import { AiDisclosure } from './components/AiDisclosure.jsx'
import { installAudioBus } from './services/audioBus'
import './styles/global.css'
import './styles/organic.css'

// Install BEFORE React renders, so every audio element any component ever
// creates is tracked from the start and can be silenced on navigation.
installAudioBus()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
    <CrisisLifeline />
    <AiDisclosure />
  </React.StrictMode>
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
